export type PortfolioInput = { volatilityBand: 'low'|'medium'|'high'; targets: { erg:number; offsets:number; futures:number }; riskAppetite: number };
export type PortfolioPlan = { erg:number; offsets:number; futures:number; note:string };

export function rebalance(i: PortfolioInput): PortfolioPlan {
  let { erg, offsets, futures } = i.targets;
  if (i.volatilityBand==='high') { futures *= 0.8; offsets *= 1.1; }
  if (i.riskAppetite<0.5) { futures *= 0.9; erg *= 1.05; }
  const sum = erg+offsets+futures || 1;
  return { erg: +(erg/sum*100).toFixed(1), offsets: +(offsets/sum*100).toFixed(1), futures: +(futures/sum*100).toFixed(1), note: 'Percent allocation' };
}



















